import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";
import i18n from "i18next";

import { Icon } from "../../Common/Icon";
import { formatNotificationDate } from "../../../helpers/dateHelpers";
import { getNotificationType } from "../../../helpers/notificationHelpers";
import RichParser from "../../Common/RichEditor/RichParser";

const NotificationCard = ({ notification, userMetadata }) => {
  const notificationType = getNotificationType(notification.messageType);

  return (
    <div className="notification-card">
      <div className="notification-card__column">
        <Icon className={classNames("notification-card__icon", notificationType.className)} id={notificationType.icon} />
        <span className="notification-card__title">{i18n.t(`notification.${notification.messageType}`)}</span>
      </div>
      <div className="notification-card__content">
        <RichParser isReadOnly value={notification.message} />
      </div>
      <span className="notification-card__footer">
        <p>
          {i18n.t("notification.sharedBy")}: {notification.sender}
        </p>
        <p>
          {i18n.t("notification.createdOn")}: {formatNotificationDate(notification.created, userMetadata.dateDisplayFormat)}
        </p>
      </span>
    </div>
  );
};

NotificationCard.propTypes = {
  notification: PropTypes.object,
  userMetadata: PropTypes.object
};

NotificationCard.defaultProps = {
  notification: {},
  userMetadata: {}
};

export default NotificationCard;



// WEBPACK FOOTER //
// ./src/components/Layout/Notifications/NotificationCard.js